/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import localforage from 'localforage';
import { IS_JEST } from './Config';

if (!IS_JEST) {
  localforage.ready()
    .catch((e) => {
      console.error(e);
    })
    .then(() => {
      console.log('localforage ready');
    });
}

export const localForage: LocalForage = IS_JEST ? {
  setItem: async () => undefined,
  getItem: async () => undefined,
  removeItem: async () => undefined
} as any : localforage;
